export default {
  uploadpoint: {
    searchPlaceholder: '输入卸货点编码查询',
    uploadPointNo: '卸货点编码',
    uploadPointName: '卸货点名称',
    status: '状态',
    remarks: '说明',
    statusOptions: ['启用', '停用'],
    addByName: '建立人',
    adddate: '建立时间',
    setUse: ['停用', '启用'],
    useConfirm: ['是否停用该卸货点?', '是否启用该卸货点?'],
    unDeleteable: '只有停用状态可删除！',
    unModifyable: '只有停用状态可修改！',
    confirmDelete: '是否删除？'
  },
  parkingSchedule: {
    searchPlaceholder: '输入仓库名称编码查询',
    receiptWareName: '仓库名称',
    receiptWareNo: '仓库编号',
    allParkNum: '卸货点总数',
    enableParkNum: '启用卸货点数',
    purchaseUnitName: '采购单位',
    wareDetailAddress: '地址',
    master: '负责人',
    phone: '联系电话',
    officeNo: '公司',
    receiptWareLabel: '仓库',
    purchaseUnitNo: '采购单位'
  },
  urgentreservation: {
    perfect: '完善信息',
    vehicleType: '车辆类型',
    numberPlatep: '车牌号码',
    vehicleDescriptionp: '车辆说明',
    urgentReasonp: '紧急预约原因',
    senderInfo: '送货人信息',
    goodInfo: '货物信息',
    searchPlaceholder: '输入送货单号进行搜索',
    dateRange: '预约日期',
    warningTip: '查询具有时效性，请及时选择卸货点!',
    date: '预计到货日期',
    startTime: '开始时间',
    endTime: '结束时间',
    uploadPointName: '卸货点',
    remarks: '卸货点说明',
    purchaseUnitName: '公司',
    receiptWareName: '仓库',
    master: '负责人',
    phone: '联系方式 ',
    checked: '已选择',
    appointmentnow: '立即预约',
    hasappointment: '已预约',
    requiredDetaillist: '请至少预约一个卸货点和时间段',
    reservationNo: '预约单号',
    urgentSign: '预约方式',
    status: '状态',
    deliveryNo: '送货单号',
    addUserName: '预约人',
    addUserDept: '预约人部门',
    urgentReason: '预约原因',
    adddate: '操作时间',
    parkingLotNo: '卸货点编号',
    parkingLotRemarks: '备注',
    numberPlate: '送货车辆',
    vehicleDescription: '车辆描述',
    supOfficeName: '供应商名称',
    deliveryRemarks: '货物描述',
    appointmentDate: '预约日期',
    period: '预约时间',
    masterPhone: '仓库负责人电话',
    deliveryPerson: '送货人',
    asnNo: '送货单号',
    expectedArrivalDate: '送达日期',
    chooseAsn: '选择送货单',
    supOfficeNo: '供应商',
    supOfficeNoLabel: '供应商编码',
    submit: '确认预约',
    recall: '撤回',
    recallConfirm: '撤回需要重新发起预约，是否撤回？',
    perfecttext: '完善',
    close: '关闭',
    closeConfirm: '是否关闭？',
    receiptWareNo: '收货仓库',
    expectArrivalDate: '预计交货日期',
    goodsNo: '料号',
    goodsName: '品名',
    deliveryQty: '发货量'
  },
  parkinglot: {
    searchPlaceholder: '输入仓库名称编码查询',
    purchaseUnitNo: '采购中心',
    master: '负责人',
    status: '状态',
    statusLabel: '是否启用',
    statusOptions: ['启用', '停用'],
    receiptWareName: '仓库名称',
    receiptWareNo: '仓库编号',
    receiptWareNoName: '仓库编码',
    wareDetailAddress: '仓库地址',
    allParkNum: '卸货点总和',
    enableParkNum: '启用卸货点数',
    autoApprovalSign: '是否自动审批',
    signOptions: ['是', '否'],
    phone: '联系电话',
    phoneNum: '电话',
    setUse: ['停用', '启用'],
    useConfirm: ['是否停用该仓库?', '是否启用该仓库?'],
    appointmentRuleSetting: '预约规则设置',
    startSubscribeTime: '预约开始时间',
    endSubscribeTime: '预约结束时间',
    minSubscribeDays: '需提前预约天数',
    autoScheduleDays: '自动排期天数',
    minSubscribeDuration: '最小预约时长',
    closeTimeoutTime: '超时关闭时间',
    allowAppointments: '允许预约的供应商',
    parkingLotNo: '编号',
    uploadPointNo: '卸货点编码',
    uploadPointName: '卸货点名称',
    uploadPointRemarks: '卸货点备注',
    remarks: '备注',
    parkingInformation: '卸货点信息',
    addTimeParking: '添加一行',
    unitDay: '天',
    unitHour: '小时',
    unitMin: '分钟'
  },
  approveappointment: {
    searchPlaceholder: '输入送货单号进行搜索',
    receiptWareId: '收货仓库',
    startDate: '预约日期-起',
    endDate: '预约日期-止',
    supOffice: '供应商名称',
    reservationNo: '预约单号',
    urgentSign: '预约方式',
    status: '状态',
    receiptWareName: '仓库名称',
    startTime: '开始时间',
    endTime: '结束时间',
    supOfficeName: '供应商',
    parkingLotNo: '卸货点编号',
    parkingLotRemarks: '备注',
    numberPlate: '送货车辆',
    vehicleDescription: '车辆描述',
    deliveryNo: '送货单号',
    deliveryRemarks: '货物描述',
    appointmentDate: '预约日期',
    period: '预约时间',
    deliveryPerson: '联系人',
    phone: '联系电话',
    manual: '批量同意',
    seeDetails: '查看详情',
    scheduling: '调度',
    complete: '完善',
    currentParkingInformation: '当前卸货点信息',
    tableTitle: '卸货点详情',
    uploadPointName: '卸货类型',
    confirmSchedule: '确认调度',
    goodsNo: '物资编码',
    goodsName: '物资名称',
    spec: '规格型号',
    deliveryQty: '发货数量',
    expectArrivalDate: '订单答交日期'
  }
}
